module.exports = __webpack_public_path__ + "media/1fie-a-lni.e291b3d8.mp3";